import * as get from 'lodash/get';

export class UrlBuilder {
	private path: string;
	private params: { [key: string]: string }[] = [];

	/**
	 * Use this like UrlBuilder.construct().setPath('test').addParam('key', 'value').build()
	 */
	public static construct(): UrlBuilder {
		return new UrlBuilder();
	}

	public setPath(path: string): UrlBuilder {
		this.path = path;
		return this;
	}

	/**
	 * Add params in the form of ?key=value if value is string and
	 * ?key=list,value1,value2 if value is an array
	 */
	public addParam(key: string, value: string | Array<any>): UrlBuilder {
		if (Array.isArray(value)) {
			value = 'list,' + value.join(',').toString();
		}
		this.params.push({ key, value });
		return this;
	}

	public build(): string {
		let parsedUrl;

		if (this.path) {
			// Set path
			parsedUrl = new URL(this.path);
			// Set params
			this.params.forEach(param => {
				if (param.key) {
					parsedUrl.searchParams.append(param.key, get(param, 'value', ''));
				}
			});
		}
		// Note: if you need the string URL, use toString() after build()
		return parsedUrl;
	}
}
